import clsx from 'clsx'
import { useRouter } from 'next/router'

/* styling */
import styles from './_.module.css'
import Button from '@/atoms/Button/Button'

function ElevateInfo(): JSX.Element {
  const router = useRouter()
  return (
    <section
      className={clsx(
        'max-width-container | border-t-2',
        styles.elevateInfoContainer
      )}
    >
      <div className="relative | grid lg:grid-cols-12 gap-8 | pt-24 pb-18 lg:py-24">
        <div className="lg:col-start-1 lg:col-end-10">
          <h2 className="font-heading text-4xl lg:text-5xl font-semibold | mb-8">
            Witness how generative AI is shaping the{' '}
            <span className={styles.textGradient1}>
              future of content marketing
            </span>
          </h2>

          <Button
            onClick={() => router.push('/elevate-generative-ai/register/')}
            className="btn-primary rounded-lg | text-xl | gap-3 | max-w-md w-full | mb-16"
          >
            Watch Recorded Sessions
          </Button>
        </div>
      </div>
    </section>
  )
}

export default ElevateInfo
